import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useClientAuth } from '../../context/ClientAuthContext';
import { hasValidToken } from '../../utils/authSession';

const ClientProtectedLayout = () => {
    const { jwtToken } = useClientAuth();
    const cookies = new Cookies();
    const token = cookies.get("tokenRC");

    if (!jwtToken || !hasValidToken(token)) {
        return <Navigate to="/client-section/login" replace />;
    }

    return <Outlet />;
};

export default ClientProtectedLayout;
